import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		dialogTitle: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
		},
		uploadRow: {
			display: "flex",
			alignItems: "center",
			flexWrap: "wrap",
			gap: 16,
			marginBottom: 16,
		},
		gallery: {
			display: "flex",
			flexWrap: "wrap",
			gap: 16,
		},
		photoCard: {
			width: 180,
			position: "relative",
		},
		thumbnail: {
			width: "100%",
			height: 120,
			objectFit: "cover",
			borderRadius: 4,
			border: `1px solid ${theme.palette.divider}`,
		},
		mainChip: {
			position: "absolute",
			top: 4,
			left: 4,
		},
		photoActions: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			marginTop: 4,
		},
		emptyState: {
			padding: 24,
			textAlign: "center",
		},
		previewStrip: {
			display: "flex",
			flexWrap: "wrap",
			gap: 8,
			marginBottom: 12,
		},
		previewThumb: {
			width: 96,
			height: 72,
			objectFit: "cover",
			borderRadius: 8,
			border: `1px solid ${theme.palette.divider}`,
		},
	} satisfies Record<string, CSSObject>);
